// window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
window.bsCarousel = require('bootstrap/js/dist/carousel.js');
window.bsCollapse = require('bootstrap/js/dist/collapse.js');
window.bsDropdown = require('bootstrap/js/dist/dropdown.js');
window.bsScrollspy = require('bootstrap/js/dist/scrollspy.js');

import EmbedRatio from './components/EmbedRatio';
import SmoothScrollTop from 'smooth-scroll-top';
import StickyHeader from './components/StickyHeader';

document.addEventListener("DOMContentLoaded", (e) => { 
    //
    EmbedRatio();
    StickyHeader();

    // Go to top button
    const scrollTop = new SmoothScrollTop({
        bgColor: '#3c8ba0',
        visibilityOffset: 300,
    });

    scrollTop.init();
});
